<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
      <ContentTile
        :themeColor="computedTopicColor"
        :title="$t('building.tile1.title')"
        :textArray="[$t('building.tile1.text')]"
      />
      <ContentImageTile
        imageSource="/img/schulhaus/09.jpg"
      />
      <ContentTile
        :themeColor="computedTopicColor"
        :title="$t('building.tile2.title')"
        :textArray="[$t('building.tile2.text')]"
      />
      <ContentGalleryTile
        v-if="photos.length > 0"
        :themeColor="computedTopicColor"
        :title="$t('building.gallery.title')"
        :photos="photos"
      />
  </ContentFrame>
</template>

<script>
import ContentTile from '@/views/components/ContentTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import ContentGalleryTile from '@/views/components/ContentGalleryTile.vue'
import ContentFrame from '@/views/components/ContentFrame.vue'
import { mapGetters } from 'vuex'

const photoSources = [
  '/img/schulhaus/01.jpg',
  '/img/schulhaus/02.jpg',
  '/img/schulhaus/03.jpg',
  '/img/schulhaus/04.jpg',
  '/img/schulhaus/05.jpg',
  '/img/schulhaus/06.jpg',
  '/img/schulhaus/11.jpg',
  '/img/schulhaus/07.jpg',
  '/img/schulhaus/08.jpg',
  '/img/schulhaus/10.jpg',
  '/img/schulhaus/12.jpg'
]

export default {
  name: 'Building',
  components: {
    ContentTile,
    ContentImageTile,
    ContentGalleryTile,
    ContentFrame
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.building.color
    },
    computedTitle () {
      return this.menuData.building.title
    },
    photos () {
      return photoSources.map((src, i) => ({
        src,
        description: this.$t(`building.photo.${i}`)
      }))
    }
  },
  watch: { }
}
</script>
